// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Button from '../core/button';
import Icon from '../core/icon';

// Styles
import './mass-action-confirm.scss';

const MassActionConfirm = ({actionsCount, label, onReset, onSubmit}) => (
    <div className="mass-action-confirm">
        <div className="mass-action-confirm--overlay-wrapper">
            <div className="mass-action-confirm--overlay">
                <Button className="mass-action-confirm--close" type="link" onClick={onReset}>
                    <Icon fontType="fa" iconName="close" />
                </Button>
                <div className="mass-action-confirm--label">{label}</div>
                {actionsCount === undefined ? (
                    <div className="mass-action-confirm--text">Are you sure you want to perform this action?</div>
                ) : actionsCount > 1 ? (
                    <div className="mass-action-confirm--text">
                        Are you sure you want to perform this action on all (
                        <span className="mass-action-confirm--count">{actionsCount}</span>) items?
                    </div>
                ) : (
                    <div className="mass-action-confirm--text">
                        Are you sure you want to perform this action on (
                        <span className="mass-action-confirm--count">{actionsCount}</span>) item?
                    </div>
                )}
                <Button className="mass-action-confirm--button" onClick={onSubmit}>
                    Yes
                </Button>
                <Button className="mass-action-confirm--button" onClick={onReset}>
                    No
                </Button>
            </div>
        </div>
    </div>
);

MassActionConfirm.propTypes = {
    actionsCount: PropTypes.number,
    label: PropTypes.string,
    onReset: PropTypes.func,
    onSubmit: PropTypes.func,
};

export default MassActionConfirm;
